import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Itemconfiguration } from './itemconfiguration/entities/itemconfiguration.entity';
import { ItemconfigurationModule } from './itemconfiguration/itemconfiguration.module';
import { ServeStaticModule } from '@nestjs/serve-static';
import { join } from 'path';

@Module({

  imports: [TypeOrmModule.forRoot({
    type: 'mysql',
    host: 'localhost',
    port: 3306,
    username: 'root',
    password: null,
    database: 'dbsoa',
    entities: [Itemconfiguration],
    synchronize: true,
  }),
  ServeStaticModule.forRoot({
    rootPath: join(__dirname, 'files'),
    // exclude: ['/api*'],
    serveStaticOptions: {
      redirect: false,
      index: false
    }
  }), ItemconfigurationModule],
  controllers: [],
  providers: [],
})
export class AppModule { }
